/**
 * Keeps Back from showing a cached page with stale applicant data.
 *
 * Browsers keep whole pages in their back/forward cache and restore them without asking
 * the server, so after a logout, Back (from this page or any other lending page cached
 * earlier) would show the applicant's details again. Each page empties itself before
 * it's cached, so the cached copy holds no applicant data, and reloads when restored,
 * which re-checks the session (https://web.dev/articles/bfcache).
 *
 * Standalone only: Online Banking owns its own pages and logout.
 *
 * Args:
 *   emptyPage: Drops the rendered app and loaded data as the page is hidden.
 */
export function guardBackForwardCache(emptyPage: () => void): void {
  window.addEventListener("pagehide", () => {
    document.documentElement.style.display = "none";
    emptyPage();
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  });
}
